import moment from 'moment';

export const ColumnEvaluationType = (translate,warning,handleEdit) => {
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <div className='div_img_table' >
                    {/*<img src={imguser} />*/}
                    <span>{row['name']}</span>
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('constraint')}</span>, width: "220px",
            cell: (row) => (
                <span>{row['constraint']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('Evaluation Type')}</span>, width: "220px",
            cell: (row) => (
                <span>{row['evaluation_type']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('ProjectTypes')}</span>, width: "220px",
            cell: (row) => (
                <span>{row.creative_work_type.name}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row) => (
                <div>
                    <i className='fa fa-edit icon_edit' onClick={(e)=> handleEdit(e,row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>
                </div>
            )
        }
    ]
    return {
        columns
    }
}

{/*<OptionsIcon warning={warning} row={row} setopenEdit={setopenEdit} handleEdit={handleEdit} />*/ }